import { Meta } from 'rc-field-form/es/interface';
import React from 'react';

/**
 * Note: We only start showing validation errors to user after the user has
 * left the field. In fact this should be a standard functionality of the form
 * library but unfortunately it is not.
 *
 * Here we control the validation state ourselves. I think introducing this
 * hook for every validated field is a good trade-off before we look for other
 * form library.
 *
 * Seems like this is not necessary for fiels whose only validation rule is
 * "required".
 */
export function useFieldController() {
  const [touched, setTouched] = React.useState<boolean>(false);

  const onMetaChange = (meta: Meta) => {
    /**
     * If validate trigger is set to "onBlur", then if the field is validating,
     * then it just basically means that it was blurred (or the whole form was
     * submitted, which should have the same effect).
     */
    if (meta.validating) {
      setTouched(true);
    }
  };

  return {
    validateTrigger: touched ? 'onChange' : 'onBlur',
    onMetaChange,
  };
}
